// src/components/AugustTabBar.js
import React from 'react'
import { TodayIcon, JourneyIcon, PracticesIcon, MomentsIcon, ProfileIcon } from './AugustTabIcons'
import './AugustTabBar.css'

// Theme-aware (was hardcoded ink) — a solid dark-mode tab bar background would make fixed-ink
// icons/labels nearly invisible. var(--text)/--aug-ink-rgb flip to cream automatically.
const INK = 'var(--text)'
const INK_MUTED = 'rgba(var(--aug-ink-rgb),0.38)'

// Favorites folded into Tracklist's filter pills (design system refresh) — 5 primary tabs, not 6.
// Tracklist itself moved from a standalone tab to a Journey sub-view; this slot is now Practices.
const TABS = [
  { id: 'today',      label: 'Today',      Icon: TodayIcon },
  { id: 'journey',    label: 'Journey',    Icon: JourneyIcon },
  { id: 'practices',  label: 'Practices',  Icon: PracticesIcon },
  { id: 'moments',    label: 'Moments',    Icon: MomentsIcon },
  { id: 'profile',    label: 'Profile',    Icon: ProfileIcon },
]

export default function AugustTabBar({ activeTab, onChange }) {
  return (
    <nav className="aug-tabbar">
      {TABS.map(({ id, label, Icon }) => {
        const active = activeTab === id
        const color = active ? INK : INK_MUTED
        return (
          <button
            key={id}
            className={`aug-tabbar-btn${active ? ' active' : ''}`}
            onClick={() => onChange(id)}
            aria-current={active ? 'page' : undefined}
          >
            <Icon size={20} color={color} />
            <span className="aug-tabbar-label" style={{ color }}>{label}</span>
          </button>
        )
      })}
    </nav>
  )
}
